import UserManagementStore from "./UserManagement/UserManagementStore";
import PermissionsStore from "./Permissions/PermissionsStore";
import RolesStore from "./Roles/RolesStore";
import ClientAccessStore from "./ClientAccess/ClientAccessStore";
import DepartmentsStore from "./Departments/DepartmentsStore";
import GitIdentitiesStore from "./GitIdentities/GitIdentitiesStore";
import PeopleStore from "./People/PeopleStore";
import PeopleAccessStore from "./People/PeopleAccessStore";

const administrationStoreList = [
  { name: "userManagementStore", store: UserManagementStore },
  { name: "permissionsStore", store: PermissionsStore },
  // NOT "rolesStore" — that key belongs to the `roles` ServiceStore
  // (serviceStores/user.stores.ts), which this view store reads from.
  { name: "roleAdminStore", store: RolesStore },
  // NOT "staffClientAssignmentsStore" — that key belongs to the ServiceStore.
  { name: "clientAccessStore", store: ClientAccessStore },
  // NOT "departmentsStore" — that key belongs to the `departments` ServiceStore.
  { name: "departmentAdminStore", store: DepartmentsStore },
  // NOT "developerGitIdentitiesStore" — that key belongs to the ServiceStore.
  { name: "gitIdentitiesStore", store: GitIdentitiesStore },
  // People (delegated user administration). NOT "delegatedPeopleStore" or
  // "userAdminDelegationsStore" — those keys belong to the ServiceStores.
  { name: "peopleStore", store: PeopleStore },
  // Whether to offer People at all (an app-wide read of your own delegation),
  // and Settings → Account security's "Changes to your access".
  { name: "peopleAccessStore", store: PeopleAccessStore },
];

export default administrationStoreList;
